// extracted by mini-css-extract-plugin
export default {"inputLabelWrapper":"Ownerships_inputLabelWrapper__bkCW1"};